"use client";

import { usePathname } from "next/navigation";

interface jsonLdProps {
    name?: string;
    description?: string;
    type?: string;
    url?: string;
    logo?: string;
    image?: string;
    priceRange?: string;
}

export default function JsonLd(props: jsonLdProps) {
    const { name, description, type, logo, url, image, priceRange } = props;

    const baseUrl = process.env.NEXT_PUBLIC_APP_URL || "";
    const telephone = process.env.NEXT_PUBLIC_COMPANY_PHONE_NUMBER || "+2348143028496";
    const email = process.env.NEXT_PUBLIC_COMPANY_EMAIL || "support@enanpay.com";

    const pathname = usePathname();

    const data:any = {
        '@context': 'https://schema.org',
        '@type': type || "",
        name: name || "Enanpay",
        description: description || "Nigeria's leading platform for daily task earning income and managing bill payments",
        url: url || baseUrl+pathname,
        logo: `${baseUrl}/logo.png`,
        image: image || "",
        mainEntity: {
            "@type": "Organization",
            name: "Enanpay",
            url: baseUrl,
            logo: `${baseUrl}/logo.png`,
            description: "Nigeria's leading platform for daily task earning income and managing bill payments.",
            foundingDate: "2023",
            founder: {
                "@type": "Person",
                name: "Ajibola Salami"
            }
        },
        contactPoint: {
            "@type": "ContactPoint",
            telephone,
            email,
            contactType: "Customer Service",
            areaServed: "NG",
            availableLanguage: "English"
        },
        address: {
            "@type": "PostalAddress",
            // streetAddress: "[Your Street Address]",
            addressLocality: "Ibadan",
            addressRegion: "Oyo",
            addressCountry: "NG"
        },
        sameAs: [
            "https://facebook.com/enanpaycom",
            "https://linkedin.com/company/enanpay",
            "https://x.com/enanpay",
            "https://instagram.com/enanpay",
            `https://wa.me/${process.env.NEXT_PUBLIC_PHONE_NUMBER || "+2348143028496"}`
        ],
        areaServed: ["Ibadan", "Lagos", "Abuja", "Port Harcourt", "Nigeria"],
        serviceType: [
            "Daily Task Earning", "Income Earning", "Data Bundle Purchase", "Airtime Topup", "Bill Payment", "Electricity Recharge", "Cable Subscription", "Earn Money Online",
        ],
        openingHours: "Mo-Fr 09:00-18:00"
    };

    if (!!priceRange) {
        data.priceRange = priceRange;
    }

    return (
        <script 
            type="application/id+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify(data).replace(/</g, '\\u003c'),
            }}
        />
    );
}